module.exports = __webpack_public_path__ + "img/stock.179929f8.svg";